<template>
    <AppLoadingContainer :predicate="!isLoaded">
        <div class="card-body">

            <div class="mb-2 text-right" v-if="canEdit">
                <button @click="isModalVisible=true" class="btn btn-primary d-print-none" data-toggle="modal"><i
                        class="fa fa-plus"></i>Add Staff Role
                </button>
            </div>

            <TheOrganizationStaffRoleForm :organization-id="organizationId" :visible="isModalVisible"
                                     @close="isModalVisible=false"
                                     :person-organization-roles="personOrganizationRoles"
                                     @create="onCreate()" v-if="canEdit"/>

            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                    <tr>
                        <th style="width:100px"></th>
                        <th>Staff Role</th>
                        <th>Person</th>
                        <th>Person Status</th>
                        <th>Organization</th>
                        <th class="text-center">Is Primary Contact</th>
                    </tr>
                    </thead>
                    <tbody>
                    <edit-organization-staff-role-table-row :key="personOrganizationRole.id"
                                                      :person-organization-role="personOrganizationRole"
                                                      :role-list="personOrganizationRoles"
                                                      @delete="onDeleteClick"
                                                      v-for="(personOrganizationRole) in personOrganizationRoles">
                    </edit-organization-staff-role-table-row>
                    </tbody>
                </table>
            </div>

        </div>
        <div class="card-footer d-print-none text-right">
            <RouterLink :to="{name:'Organizations'}" class="btn btn-danger">Back</RouterLink>
        </div>
        <AppModalConfirm :visible="deletingRow" @close="deletingRow=null" @confirm="onDeleteConfirmed(deletingRow)">
            <template v-slot:header>Confirm</template>
            <p v-if="deletingRow">Are you sure you want to delete the role '{{deletingRow.organizationRoleName}}'?</p>
        </AppModalConfirm>
    </AppLoadingContainer>
</template>

<script>
    import OrganizationService from "../../services/OrganizationService";
    import AppLoadingContainer from "../shared/AppLoadingContainer";
    import EditOrganizationStaffRoleTableRow from "@/components/organizations/OrganizationStaffRoleRow";
    import TheOrganizationStaffRoleForm from "@/components/organizations/TheOrganizationStaffRoleForm";
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppModalConfirm from "@/components/shared/AppModalConfirm";
    import {ApplicationRole} from "@/services/models/Role";

    export default {
        components: {
            TheOrganizationStaffRoleForm,
            AppLoadingContainer,
            EditOrganizationStaffRoleTableRow,
            AppModalConfirm,
        },
        data() {
            return {
                isLoaded: false,
                isModalVisible: false,
                deletingRow: null,
                personOrganizationRoles: [],
            }
        },
        props: {
            organizationId: {
                type: String,
                required: true
            }
        },
        computed: {
            /**
             * @description Indicates if this form can be edited by the person based on the given role
             * @returns {boolean}
             */
            canEdit() {
                return this.hasApplicationRole(ApplicationRole.DatabaseAdministrator, ApplicationRole.Business, ApplicationRole.TTIWebsiteAdministrator);
            }
        },
        methods: {
            /**
             * @description Reloads the data
             */
            onCreate() {
                this.loadData();
            },

            /**
             * @description Opens up a modal to confirm deletion of the organization role
             */
            onDeleteClick(organizationRole) {
                this.deletingRow = organizationRole;
            },

            /**
             * @description When the user clicks 'Confirm' - the selected organization role will be deleted and the modal will be closed.
             */
            onDeleteConfirmed(deletingRow) {
                const vm = this;

                OrganizationService.deleteOrganizationRole(deletingRow.id).then(() => {
                    vm.alert(ToastType.Success, `The ${deletingRow.organizationRoleName} staff role was successfully deleted.`);

                    vm.loadData();
                }).catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    })
                    .finally(() => {
                        vm.deletingRow = null;
                    });
            },

            /**
             * @description Loads the organization roles for the current organization
             */
            loadData() {
                const vm = this;
                vm.isLoaded = false;

                OrganizationService.getOrganizationRoles(this.organizationId, true)
                    .then(response => {
                        vm.personOrganizationRoles = response;
                    }).catch(() => {
                    vm.redirectToError();
                }).finally(() => {
                    vm.isLoaded = true
                })
            }
        },
        created() {
            this.loadData();
        },
    }
</script>
